import { Union } from "../fable_modules/fable-library.3.6.3/Types.js";
import { union_type, array_type, int32_type, tuple_type, string_type, class_type } from "../fable_modules/fable-library.3.6.3/Reflection.js";
import { FileByteArray, IServerApi$reflection, Route_builder, IncludePos$reflection, DownloadFormat$reflection, FileByteArray$reflection, TaggedTextInfo$reflection } from "../Shared/fs/Shared.js";
import { RemotingModule_createApi, RemotingModule_withRouteBuilder, Remoting_buildProxy_Z15584635 } from "../fable_modules/Fable.Remoting.Client.7.18.0/Remoting.fs.js";
import { Lemma, Model, TaggingStatus as TaggingStatus_1 } from "./Model.js";
import { Cmd_OfAsync_start, Cmd_OfAsyncWith_perform, Cmd_none } from "../fable_modules/Fable.Elmish.3.1.0/cmd.fs.js";
import { Browser_Types_File__File_ReadAsByteArray, ByteArrayExtensions_SaveFileAs_72B26259 } from "../fable_modules/Fable.Remoting.Client.7.18.0/Extensions.fs.js";
import { singleton, collect, delay, toArray } from "../fable_modules/fable-library.3.6.3/Seq.js";
import { singleton as singleton_1 } from "../fable_modules/fable-library.3.6.3/AsyncBuilder.js";
import { some } from "../fable_modules/fable-library.3.6.3/Option.js";

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["TagText", "TaggedText", "DownloadTaggedText", "DownloadedTaggedText", "FetchLemmas", "FetchedLemmas", "DownloadLemmas", "DownloadedLemmas", "DownloadLemmatizedText", "DownloadedLemmatizedText"];
    }
}

export function Msg$reflection() {
    return union_type("Update.Msg", [], Msg, () => [[["Item", class_type("Browser.Types.File")]], [["Item", TaggedTextInfo$reflection()]], [], [["Item", FileByteArray$reflection()]], [], [["Item", array_type(tuple_type(tuple_type(string_type, string_type), int32_type))]], [["Item", DownloadFormat$reflection()]], [["Item", FileByteArray$reflection()]], [["Item", IncludePos$reflection()]], [["Item", FileByteArray$reflection()]]]);
}

export const serverApi = Remoting_buildProxy_Z15584635(RemotingModule_withRouteBuilder((typeName, methodName) => Route_builder(typeName, methodName), RemotingModule_createApi()), {
    ResolveType: IServerApi$reflection,
});

export function init() {
    return [new Model(void 0, new TaggingStatus_1(0), void 0, void 0, void 0), Cmd_none()];
}

export function update(msg, model) {
    let matchValue, matchValue_1, matchValue_3, matchValue_5;
    switch (msg.tag) {
        case 1: {
            return [new Model(model.Filename, new TaggingStatus_1(2), msg.fields[0], model.Lemmas, model.DownloadFormat), Cmd_none()];
        }
        case 2: {
            return [model, (matchValue = model.TaggedTextInfo, (matchValue == null) ? (() => {
                throw (new Error("Content hash missing!"));
            })() : Cmd_OfAsyncWith_perform((x_1) => {
                Cmd_OfAsync_start(x_1);
            }, serverApi.DownloadTaggedText, matchValue.ContentHash, (arg0_1) => (new Msg(3, arg0_1))))];
        }
        case 3: {
            ByteArrayExtensions_SaveFileAs_72B26259(msg.fields[0].fields[0], `${model.Filename}.tag.txt`);
            return [model, Cmd_none()];
        }
        case 4: {
            return [model, (matchValue_1 = model.TaggedTextInfo, (matchValue_1 == null) ? (() => {
                throw (new Error("Content hash missing!"));
            })() : Cmd_OfAsyncWith_perform((x_2) => {
                Cmd_OfAsync_start(x_2);
            }, serverApi.GetLemmas, matchValue_1.ContentHash, (arg0_2) => (new Msg(5, arg0_2))))];
        }
        case 5: {
            return [new Model(model.Filename, model.TaggingStatus, model.TaggedTextInfo, toArray(delay(() => collect((matchValue_2) => singleton(new Lemma(matchValue_2[1], matchValue_2[0][0], matchValue_2[0][1])), msg.fields[0]))), model.DownloadFormat), Cmd_none()];
        }
        case 6: {
            const format = msg.fields[0];
            return [new Model(model.Filename, model.TaggingStatus, model.TaggedTextInfo, model.Lemmas, format), (matchValue_3 = model.TaggedTextInfo, (matchValue_3 == null) ? (() => {
                throw (new Error("Content hash missing!"));
            })() : Cmd_OfAsyncWith_perform((x_3) => {
                Cmd_OfAsync_start(x_3);
            }, serverApi.DownloadLemmas, [matchValue_3.ContentHash, format], (arg0_4) => (new Msg(7, arg0_4))))];
        }
        case 7: {
            let extension;
            const matchValue_4 = model.DownloadFormat;
            if (matchValue_4 == null) {
                throw (new Error("Download format not set!"));
            }
            else {
                extension = ((matchValue_4.tag === 1) ? "tsv" : ((matchValue_4.tag === 2) ? "csv" : "xlsx"));
            }
            ByteArrayExtensions_SaveFileAs_72B26259(msg.fields[0].fields[0], `${model.Filename}.lemmas.${extension}`);
            return [model, Cmd_none()];
        }
        case 8: {
            return [model, (matchValue_5 = model.TaggedTextInfo, (matchValue_5 == null) ? (() => {
                throw (new Error("Content hash missing!"));
            })() : Cmd_OfAsyncWith_perform((x_4) => {
                Cmd_OfAsync_start(x_4);
            }, serverApi.DownloadLemmatizedText, [matchValue_5.ContentHash, msg.fields[0]], (arg0_5) => (new Msg(9, arg0_5))))];
        }
        case 9: {
            ByteArrayExtensions_SaveFileAs_72B26259(msg.fields[0].fields[0], `${model.Filename}.lemmatized.txt`);
            return [model, Cmd_none()];
        }
        default: {
            const file = msg.fields[0];
            return [(file.size <= 1048576) ? (new Model(file.name, new TaggingStatus_1(1), void 0, void 0, model.DownloadFormat)) : model, (file.size <= 1048576) ? Cmd_OfAsyncWith_perform((x) => {
                Cmd_OfAsync_start(x);
            }, () => singleton_1.Delay(() => singleton_1.Bind(Browser_Types_File__File_ReadAsByteArray(file), (_arg1) => singleton_1.ReturnFrom(serverApi.TagText(new FileByteArray(0, _arg1))))), void 0, (arg0) => (new Msg(1, arg0))) : ((window.alert(some("Filstørrelsen overstiger maksimum på 1 MB!")), Cmd_none()))];
        }
    }
}

